import { useDroppable } from "@dnd-kit/core";
import { Stack } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  containerId: string;
};

export function DroppableContainer({ children, containerId }: Props) {
  const { setNodeRef } = useDroppable({
    id: containerId,
  });
  return (
    <Stack ref={setNodeRef} spacing={1}>
      {children}
    </Stack>
  );
}
